import React from 'react';
import { Typography } from '@mui/material';

// Heading Component
export default function Heading({ children }: { children: React.ReactNode }) {
  return (
    <Typography
      component="h1"
      sx={{
        fontSize: (theme) => theme.typography.h4.fontSize,
      }}
    >
      {children}
    </Typography>
  );
}